import {getRunningTimeData} from '@domain/running-times'
import {type EquipmentRunningTimes, RunningTimeType} from '@hconnect/common/types'
import {TFunction} from 'i18next'
import {orderBy} from 'lodash'

import {RunningTimeDropDownItem} from '../types'

export const getRunningTimeDropdownItems = (
  runningTimes: EquipmentRunningTimes[],
  language: string,
  t: TFunction
): RunningTimeDropDownItem[] =>
  orderBy(
    runningTimes
      .map(({runningTimes, equipment}) => {
        return runningTimes
          .filter(
            ({runningTimeType, stoppages}) =>
              runningTimeType === RunningTimeType.STOPPED && !stoppages
          )
          .map((runningTime) => {
            return {
              label: getRunningTimeData(runningTime, language, t),
              runningTime,
              equipment: equipment
            }
          })
      })
      .flat()
      .map((runningTime, index) => ({...runningTime, id: String(index)})),
    ({runningTime}) => new Date(runningTime.beginTechnical?.valueOf() || ''),
    'desc'
  )
